module.exports = __webpack_public_path__ + "img/hr-tank-base-mask-1.3a1a7097.png";